import { Injectable } from "@angular/core";
import { BaseHttpClient } from "@peca/commons";
import { environment } from "apps/backoffice/src/environments/environment";
import { TSetting } from "../types/settings.type";
import { Pageable } from "@peca/backoffice/models/pageable.model";

@Injectable({ providedIn: 'root' })
export class SettingsService extends BaseHttpClient {
  baseUrl = `${environment.gateway.url}/backoffice/v2/settings`;

  getLastSetting<Type extends object>(key: string) {
    return this.http.get<TSetting<Type>>(`${this.baseUrl}/${key}`);
  }

  getAllVersionsOfSetting<Type extends object>(key: string, params?: { page?: number; size?: number; sort?: string }) {
    return this.http.get<Pageable<TSetting<Type>>>(`${this.baseUrl}/${key}/versions`, { params: params as Record<string, string | number> });
  }

  getSettingVersion<Type extends object>(key: string, version: number) {
    return this.http.get<TSetting<Type>>(`${this.baseUrl}/${key}/versions/${version}`);
  }

  updateSetting<Type extends object>(key: string, value: Type) {
    return this.http.put<TSetting<Type>>(`${this.baseUrl}/${key}`, value);
  }
}
